import React, { useEffect, useState } from "react"
import Select from "react-select"
import { useForm, Controller } from "react-hook-form"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
} from "reactstrap"
import { getTasksLi } from "../../../services/Settings/dropdown"
import { UFEditor, UFInput } from "../Fields/Input"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const TasksList = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  estimationId,
  currentTask,
  projectId,
  revisonId,
  showCreateOption = false,
  onCreate,
  invalid,
}) => {
  const modalForm = useForm({
    defaultValues: {
      name: "",
      description: "",
    },
  })

  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [field1, setField1] = useState("")
  const [field2, setField2] = useState("")
  const [field1Error, setField1Error] = useState("")
  const [field2Error, setField2Error] = useState("")

  const loadOptions = async () => {
    setIsLoading(true)
    const data = await getTasksLi({
      estimationId,
      currentTask,
      projectId,
      revisonId,
    })
    const response = data?.data?.map(dta => ({
      label: dta?.name && ucfirst(dta.name),
      value: dta.id,
      ...dta,
    }))
    let options = [...response]
    if (showCreateOption) {
      options.unshift({
        label: "Create",
        value: "create",
        isCreateButton: true,
      })
    }
    setFetchResponse(options)
    setIsLoading(false)
  }
  const handleCreate = () => {
    const { name, description } = modalForm.getValues()
    let valid = true
    if (!name) {
      setField1Error("Task Name is required")
      valid = false
    } else {
      setField1Error("")
    }
    if (!description) {
      setField2Error("Description is required")
      valid = false
    } else {
      setField2Error("")
    }
    if (!valid) return

    if (onCreate) onCreate({ name, description })
    setShowModal(false)
    modalForm.reset()
  }
  useEffect(() => {
    if (estimationId || projectId) {
      loadOptions()
    }
  }, [estimationId, currentTask, projectId, revisonId])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid: fieldInvalid },
        }) => (
          <Select
            options={fetchResponse}
            // placeholder={placeholder ? placeholder : "Select"}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            invalid={invalid || fieldInvalid}
            onChange={e => {
              if (e?.isCreateButton) {
                setShowModal(true)
              } else {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }
            }}
            value={value}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          />
        )}
      />

      <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
        <ModalHeader toggle={() => setShowModal(false)}>
          Create New Task
        </ModalHeader>
        <ModalBody>
          <FormGroup className="mb-4">
            <Label>Task Name<span className="mandatory">*</span></Label>
            <Controller
              control={modalForm.control}
              name="name"
              render={({ field, fieldState }) => (
                <UFInput
                  {...field}
                  control={modalForm.control}
                  placeholder="Enter the Task Name"
                  invalid={!!fieldState.error}
                />
              )}
            />
            <FormFeedback invalid>
              {modalForm.formState.errors.name?.message}
            </FormFeedback>
          </FormGroup>
          <FormGroup className="mb-4">
            <Label>Description<span className="mandatory">*</span></Label>
            <Controller
              control={modalForm.control}
              name="description"
              render={({ field, fieldState }) => (
                <UFEditor
                  {...field}
                  control={modalForm.control}
                  row="5"
                  placeholder="Enter the Description"
                  invalid={!!fieldState.error}
                />
              )}
            />
            <FormFeedback invalid>
              {modalForm.formState.errors.description?.message}
            </FormFeedback>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleCreate}>
            Create
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}
export default TasksList
